/*
* Palo Alto Theme
*
* Use this file to add custom Javascript to Palo Alto.  Keeping your custom
* Javascript in this fill will make it easier to update Palo Alto. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/
(function () {
    function wrapElement(el, wrapper) {
        // Crea un nuovo elemento div
        wrapper = wrapper || document.createElement('div');

        // Inserisci il wrapper prima dell'elemento
        el.parentNode.insertBefore(wrapper, el);

        // Sposta l'elemento all'interno del wrapper
        return wrapper.appendChild(el);
    }

    function isScriptLoaded(src) {
        return document.querySelector(`script[src="${src}"]`) !== null;
    }

    // video into product page
    document.querySelectorAll('.product__block.product__description :not(.product-generic-video) iframe').forEach((element) => {
        let wrapper = document.createElement('div');
        wrapper.classList.add('product-generic-video')
        wrapElement(element, wrapper)
    })
    // accessibility
    const loadAW = (open) => {
        (function () {
            let script_url = "https://acsbapp.com/apps/app/dist/js/app.js";
            let open_fn = () => {
                setTimeout(function () {
                    const el = document.querySelector('.acsb-trigger')
                    if (el) {
                        el.click()
                    } else {
                        open_fn()
                    }
                }, 500);
            }
            if (!isScriptLoaded(script_url)) {
                let s = document.createElement("script"),
                    e = !document.body ? document.querySelector("head") :
                        document.body;
                s.src = script_url;
                s.async = true;
                s.onload = function () {
                    acsbJS.init({
                        statementLink: theme.routes.shop_url + '/pages/accessibility',
                        footerHtml: '<a href="https:www.accessiway.com/">AccessiWay. The Web Accessibility Solution</a>',
                        hideMobile: false,
                        hideTrigger: true,
                        language: "it",
                        position: "left",
                        leadColor: "#f95a6d",
                        triggerColor: "#f44764",
                        triggerRadius: "10%",
                        triggerPositionX: "left",
                        triggerPositionY: "bottom",
                        triggerIcon: "people",
                        triggerSize: "medium",
                        triggerOffsetX: 20,
                        triggerOffsetY: 20,
                        mobile: {
                            triggerSize: "medium",
                            triggerPositionX: "left",
                            triggerPositionY: "bottom",
                            triggerOffsetX: 10,
                            triggerOffsetY: 10,
                            triggerRadius: "50%",
                        },
                    });
                    if (open) {
                        open_fn()
                    }
                };
                e.appendChild(s);
            } else {
                if (open) {
                    open_fn();
                }
            }
        })();
    }
    let accessibility_element = document.querySelector('footer .footer-block:nth-of-type(2) .footer-links li:last-of-type a')
    accessibility_element.innerHTML = "<img class='footer__icon' src='" + theme.assets.base + "/icona-accessibilita.svg' alt='accessibility'/>" + accessibility_element.innerHTML
    document.querySelector('footer .footer-block:nth-of-type(2) .footer-links li:last-of-type').addEventListener("click", (event) => {
        event.preventDefault();
        loadAW(true)
    })
    const gtmSetPosition = function () {
        let productsGrid = document.querySelectorAll('.collection__products, .carousel')
        if (productsGrid) {
            productsGrid.forEach((gridElement) => {
                let allProducts = gridElement.querySelectorAll('.product-grid-item')
                if (allProducts) {
                    allProducts.forEach((element, index) => {
                        element.dataset.gtmPosition = index + 1
                    })
                }
            })
        }
    }
    gtmSetPosition()
    // ^^ Keep your scripts inside this IIFE function call to
    // avoid leaking your variables into the global scope.
})();
